import { forwardRef } from "react";

import { DashboardIcon, DashboardIconProps } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardTooltip, DashboardTooltipProps } from "@/dashboard-design-system/Tooltip/DashboardTooltip";
import { mergeSx } from "@/helpers/mergeSx";
import { Info as InfoIcon } from "@/icons/outlined";

export type DashboardInformationTooltipProps = Omit<DashboardTooltipProps, "children" | "disabled"> & {
  alignOnText?: boolean;
  alignOffset?: string;
  slotProps?: DashboardTooltipProps["slotProps"] & {
    icon?: Omit<DashboardIconProps, "ref" | "children">;
  };
};

export const DashboardInformationTooltip = forwardRef<HTMLDivElement, DashboardInformationTooltipProps>(
  ({ alignOnText = false, alignOffset, slotProps, ...rest }, ref) => {
    const { icon: iconProps, ...tooltipProps } = slotProps ?? {};

    const iconStyles = mergeSx(
      {
        display: "inline-flex",
        cursor: "help",
        ...(alignOnText && {
          position: "relative",
          top: alignOffset || "0.25rem",
        }),
      },
      iconProps?.sx
    );
    return (
      <DashboardTooltip {...rest} ref={ref} slotProps={tooltipProps}>
        <DashboardIcon vibe="text-neutral-supershy" {...(iconProps ?? {})} sx={iconStyles}>
          <InfoIcon />
        </DashboardIcon>
      </DashboardTooltip>
    );
  }
);

DashboardInformationTooltip.displayName = "DashboardInformationTooltip";
